/// <amd-module name="SuiteCommerce.GridOrder.Common.DependencyProvider"/>
define("SuiteCommerce.GridOrder.Common.DependencyProvider", ["require", "exports", "underscore", "Profile.Model", "Utils"], function (require, exports, _, ProfileModelModule, UtilsModuleSC) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ProfileModel = getDependency(ProfileModelModule);
    exports.UtilsModule = getDependency(UtilsModuleSC);
    function getDependency(module) {
        if (isTranspiledModule(module)) {
            return module[Object.keys(module)[0]];
        }
        return module;
    }
    function isTranspiledModule(module) {
        var moduleKeys = Object.keys(module);
        return !_.isFunction(module) && moduleKeys.length === 1;
    }
});
